<template>
  <div>
    <el-row>
      <el-col>
        <el-button
          type="primary"
          size="small"
          @click.native="downloadCSV()"
        >
          Generate Report
        </el-button>
      </el-col>
    </el-row>
    <Preview
      v-if="isShowPreview"
      title="Stuck Invoices Report"
      :is-show.sync="isShowPreview"
      :configuration="configuration"
    />
  </div>
</template>

<script>
import Preview from '@/components/Application/Reports/Preview'

export default {
  components: {
    Preview
  },
  data () {
    return {
      breadcrumb: {
        name: 'Stuck Invoices Report',
        route: { name: 'reports-invoice-carrier' }
      },
      isShowPreview: false,
      configuration: null
    }
  },
  methods: {
    async downloadCSV () {
      this.configuration = {
        report: 'StuckInvoicesReport',
        params: {}
      }
      this.isShowPreview = true
    }
  }
}
</script>
